import { Control } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { NativeSelectInputController } from "#shared/view/designSystem/inputs/NativeSelectInputController";
import { FilterQuery, Operator } from "shared";

type Props = {
  operators: Operator[];
  expressionIndex: number;
  control: Control<FilterQuery>;
};

export const FilterOperatorInputController = ({ operators, expressionIndex, control }: Props) => {
  const { t } = useTranslation();
  const availableOperatorsOptions = operators.map((operator) => ({
    value: operator,
    label: t(`filterOperators.${operator}`),
  }));

  return (
    <NativeSelectInputController
      name={`filterGroup.expressions.${expressionIndex}.operator`}
      control={control}
      data={availableOperatorsOptions}
      withEmptyData={false}
    />
  );
};
